import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=5fc10baa&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc10baa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fc10baa')) {
      api.createRecord('5fc10baa', component.options)
    } else {
      api.reload('5fc10baa', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=5fc10baa&scoped=true&", function () {
      api.rerender('5fc10baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Gr4SuFErSqSY/JS/comp/Voucher-Unit.vue"
export default component.exports